exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html,body{overflow:hidden}.app{text-align:center}.app .leave-behind{position:absolute;top:0}\n", ""]);

// exports
